import React from 'react'
import { useTheme } from '~/common/theme'

import Text from '~/views/components/ui/Text'

import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
  Button,
} from './styled'

interface Props {
  onClose(): void
  open: boolean
  onPrimaryAction?(): void
  onSecondaryAction?(): void
  primaryLabel?: string
  secondaryLabel?: string
  title: string | React.ReactNode
  body: string | React.ReactNode
  className?: string

  /**
   * ActionDialog children will replace the default
   * DialogActions
   */
  children?: React.ReactNode
}

const ActionDialog = ({
  onClose,
  open,
  onPrimaryAction,
  onSecondaryAction,
  primaryLabel = '',
  secondaryLabel = '',
  className,

  title,
  body,
  children,
}: Props) => {
  const theme = useTheme()

  return (
    <Dialog
      title=""
      open={open}
      onClose={onClose}
      showLine={false}
      closeSize={theme.spacing(3)}
      className={className}
    >
      <DialogTitle>
        <Text size="xl" weight="bold" className="dialog-title">
          {title}
        </Text>
      </DialogTitle>

      <DialogBody>
        <Text size="sixteen" className="dialog-body">
          {body}
        </Text>
      </DialogBody>

      <DialogActions>
        {children && children}

        {!children && (
          <>
            <Button onClick={onSecondaryAction} size="large" color="primary">
              {secondaryLabel.toUpperCase()}
            </Button>
            <Button onClick={onPrimaryAction} size="large" raised>
              {primaryLabel.toUpperCase()}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default ActionDialog
